import { render, staticRenderFns } from "./NavBottom.vue?vue&type=template&id=af258898&scoped=true&"
import script from "./NavBottom.vue?vue&type=script&lang=js&"
export * from "./NavBottom.vue?vue&type=script&lang=js&"
import style0 from "./NavBottom.vue?vue&type=style&index=0&id=af258898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af258898",
  null
  
)

export default component.exports